"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanttView = exports.DEFAULT_WORK_DAYS = void 0;
const config_1 = require("../../config");
const engine_1 = require("../../engine");
const field_1 = require("../../model/field");
const types_1 = require("../../types");
const utils_1 = require("../../utils");
const i18n_1 = require("../../exports/i18n");
const store_1 = require("../../exports/store");
const selectors_1 = require("../../exports/store/selectors");
const datasheet_1 = require("../datasheet");
const views_1 = require("./views");
exports.DEFAULT_WORK_DAYS = [1, 2, 3, 4, 5];
class GanttView extends views_1.View {
    get recordShowName() {
        return (0, i18n_1.t)(i18n_1.Strings.gantt_task);
    }
    get recordShowUnit() {
        return '';
    }
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.gantt_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.gantt_guide_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_gantt_guide_video.value),
        };
    }
    static findDateTimeFieldIds(srcView, fieldMap, state) {
        const filterIds = srcView.columns.filter(({ fieldId }) => {
            const field = fieldMap[fieldId];
            return field_1.Field.bindModel(field, state).basicValueType === types_1.BasicValueType.DateTime;
        }).map(column => column.fieldId);
        return filterIds;
    }
    static defaultStyle(snapshot, activeViewId, state) {
        const srcView = this.getSrcView(snapshot, activeViewId);
        const dateTimeFieldIds = this.findDateTimeFieldIds(srcView, snapshot.meta.fieldMap, state);
        return {
            startFieldId: dateTimeFieldIds[0],
            endFieldId: dateTimeFieldIds[1] || dateTimeFieldIds[0],
            colorOption: {
                type: store_1.GanttColorType.Custom,
                fieldId: '',
                color: -1,
            },
            workDays: exports.DEFAULT_WORK_DAYS,
            onlyCalcWorkDay: false,
            linkFieldId: '',
            autoTaskLayout: false
        };
    }
    static defaultColumns(srcView) {
        if (!srcView) {
            throw Error((0, i18n_1.t)(i18n_1.Strings.error_not_found_the_source_of_view));
        }
        const columns = srcView.columns.map((column, index) => {
            const fieldId = column.fieldId;
            if (index === 0) {
                return { fieldId };
            }
            return { fieldId, hiddenInGantt: true, hidden: true };
        });
        return columns;
    }
    static generateDefaultProperty(snapshot, activeViewId, state) {
        const srcView = this.getSrcView(snapshot, activeViewId);
        const views = snapshot.meta.views;
        return {
            id: datasheet_1.DatasheetActions.getNewViewId(views),
            name: datasheet_1.DatasheetActions.getDefaultViewName(views, store_1.ViewType.Gantt),
            type: store_1.ViewType.Gantt,
            rowHeightLevel: 1,
            columns: this.defaultColumns(srcView),
            rows: this.defaultRows(srcView),
            frozenColumnCount: 1,
            style: this.defaultStyle(snapshot, activeViewId, state),
            displayHiddenColumnWithinMirror: true
        };
    }
}
exports.GanttView = GanttView;
GanttView.setGanttStyle2Action = (snapshot, payload) => {
    const { viewId, data } = payload;
    const viewIndex = (0, selectors_1.getViewIndex)(snapshot, viewId);
    if (viewIndex < 0)
        return [];
    const view = snapshot.meta.views[viewIndex];
    if (view.type !== store_1.ViewType.Gantt)
        return [];
    return data.filter(({ styleKey, styleValue }) => {
        return styleValue !== view.style[styleKey];
    }).map(({ styleKey, styleValue }) => {
        return {
            n: engine_1.OTActionName.ObjectReplace,
            p: ['meta', 'views', viewIndex, 'style', styleKey],
            oi: styleValue,
            od: view.style[styleKey],
        };
    });
};
//# sourceMappingURL=gantt_view.js.map